import client from "./apiConfig";
import { AppSettings } from "./api.setting";

export default {
  async getAllProject() {
    const response = await client.get(AppSettings.API_GET_ALL_PROJECT);
    return response;
  },
};
